import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { Observable, Subject } from 'rxjs';

const TradingWorkspaceDestroyContext = createContext<
  Observable<void> | undefined
>(undefined);

export const TradingWorkspaceDestroyProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const destroy$ = useMemo(() => new Subject<void>(), []);

  useEffect(() => {
    return () => {
      destroy$.next();
      destroy$.complete();
    };
  }, [destroy$]);

  return React.createElement(
    TradingWorkspaceDestroyContext.Provider,
    { value: destroy$.asObservable() },
    children
  );
};

export const useTradingWorkspaceDestroy$ = () => {
  const context = useContext(TradingWorkspaceDestroyContext);
  if (!context) {
    throw new Error(
      'useTradingWorkspaceDestroy$ must be used within TradingWorkspaceDestroyProvider'
    );
  }

  return context;
};
